import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    marging: 0 auto;
    width: 100%;
    display: block;
    > {
        margin: 0 auto;
    }
`

const IFrame = styled.iframe.attrs({
    width: "300",
    height: "380",
    frameborder: "0",
    allowtransparency: true,
    allow: "encrypted-media"
})`
    border: none;
`

interface ISpotifyEmbed {
    uri: string
}

const SpotifyEmbed : React.FC<ISpotifyEmbed> = ({ uri }) => {

    return (
        <Container>
            <IFrame src={ "https://open.spotify.com/embed/track/" + uri} />
        </Container>
    )

}

export default SpotifyEmbed;